<template>
    <b-alert
        class="sub-assignment-show-feedback"
        v-if="($authUser.isStudent() && subAssignmentIn.hasFeedback()) || !$authUser.isStudent()"
        variant="warning"
        show>
        <div
            class="message-list apprentice-messages-widget"
            v-if="subAssignmentIn.hasFeedback()"
            ref="messageListContainer">
            <div
                class="message-item"
                v-for="feedback in filteredFeedback"
                :key="feedback.id"
                :class="feedback.user_id === $authUser.id ? 'left' : 'right'">
                <div class="user-info">
                    <div class="credentials">{{ feedback.user.full_name }}</div>
                    <div class="date">{{ feedback.created_at | date_time_om }}</div>
                </div>
                <div class="message-block">
                    <div class="message-content">
                        <div class="arrow"></div>
                        <b-collapse
                            class="feedback-textcontent"
                            id="feedback-text-block">
                            <design-2021-apprentice-display-html-component :html-content="feedback.text">
                            </design-2021-apprentice-display-html-component>
                        </b-collapse>

                        <div
                            class="more-and-less"
                            v-if="hasContentToPreview(feedback.text, 50)">
                            <b-button
                                v-b-toggle:feedback-text-block
                                variant="link-type">
                                <span class="when-open btn-show-less">Verberg</span>
                                <span class="when-closed btn-show-more"> Toon meer</span>
                            </b-button>
                        </div>
                    </div>
                    <div class="avatar">
                        <b-avatar
                            variant="primary"
                            size="3rem"
                            :src="
                                feedback.user.profile_image_thumb_path
                                    ? feedback.user.profile_image_thumb_path
                                    : '/images/default_avatar_profile.jpg'
                            ">
                        </b-avatar>
                    </div>
                </div>

                <design-2021-sub-assignment-show-edit-feedback-modal-component :feedback-in="feedback">
                </design-2021-sub-assignment-show-edit-feedback-modal-component>
            </div>

            <div
                class="show-feedback-history"
                v-if="subAssignmentIn.feedback.length > 1">
                <b-button
                    class="btn-link-type btn-show-more btn-show-sub-assignment-feedback-history"
                    v-b-modal="'sub-assignment-feedback-details-modal'"
                    variant="primary">
                    {{ `Toon alles (${subAssignmentIn.feedback.length})` }}
                </b-button>
            </div>
        </div>
    </b-alert>
</template>

<script>
import { ords } from '../../../../../app';

export default {
    name: 'design-2021-assignment-show-sub-assignment-feedback-component',
    props: {
        subAssignmentIn: Object,
        projectId: Number,
        assignmentIdIn: Number,
    },
    data() {
        return {
            text: this.subAssignmentIn.feedback ? this.subAssignmentIn.feedback.text : '',
            showAll: false,
        };
    },
    methods: {
        showFeedbacks(id) {
            this.$bvModal.show('sub-assignment-show-edit-feedback-modal' + id);
        },

        saveFeedback() {
            if (!this.text && (!this.subAssignmentIn.feedback || !this.subAssignmentIn.feedback.text)) {
                return;
            }

            const data = {
                sub_assignment_id: this.subAssignmentIn.id,
                text: this.text,
                project_id: this.projectId,
                assignment_id: this.assignmentIdIn,
            };

            this.axios.post(this.routes.subAssignmentFeedback(), data).then(
                (response) => {
                    this.subAssignmentIn.addRelation('feedback', response.data);

                    this.text = '';

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removeFeedback(id) {
            this.alert
                .confirm('Feedback verwijderen', 'Weet je zeker dat je de feedback wil verwijderen?')
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();
                    this.axios.delete(this.routes.subAssignmentFeedbackDelete(id)).then(
                        (response) => {
                            ords.use('subAssignmentFeedback').remove(id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        canEdit(message) {
            return message.user_id === this.$authUser.id;
        },

        hasContentToPreview(text, maxChar) {
            let feedbackText = text;
            if (text.lastIndexOf(`<p>&nbsp;</p>`)) {
                feedbackText = text.slice(0, text.lastIndexOf(`<p>&nbsp;</p>`));
            }

            const previewText = this.$options.filters.strip_html_tags(text);
            return (
                feedbackText.includes('<table>') ||
                feedbackText.includes('<ul>') ||
                feedbackText.includes('<ol>') ||
                feedbackText.includes('<br>') ||
                feedbackText.includes('&nbsp;') ||
                previewText.length > maxChar
            );
        },
    },

    computed: {
        filteredFeedback() {
            let feedback = [];

            // Todo: Filter for any unread feedback-messages

            // Else show latest message
            if (this.subAssignmentIn.hasFeedback()) {
                feedback = this.subAssignmentIn.feedback
                    .map((feedback) => feedback)
                    .sort((a, b) => (a.created_at > b.created_at ? 1 : -1));
                return feedback.splice(-1);
            }

            return feedback;
        },
    },
};
</script>

<style scoped lang="scss">
.collapsed > .when-open,
.not-collapsed > .when-closed {
    display: none;
}

.sub-assignment-show-feedback {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    background-color: $feedback-alert-bg-color;
    color: $text-color;
    border-radius: $border-radius-content;
    box-shadow: 0 0 0 1px $feedback-alert-border-color;

    .credentials,
    .date {
        font-weight: $font-weight-bold;
    }

    div.apprentice-messages-widget {
        div.message-item {
            div.textmessage {
                margin-left: 0;
                padding: 0;
                border-radius: 0;
                background-color: transparent;
                width: 100%;
            }
        }
    }

    .message-block {
        margin-top: map-get($grid-gutter-spacing, 'ten');
        flex-direction: row-reverse;

        .message-content {
            position: relative;
            display: flex;
            flex: 1;
            flex-wrap: nowrap;
            flex-direction: column;
            width: calc(100% - 20px);
            background-color: $white;
            padding: map-get($grid-gutter-spacing, 'fifteen');
            border-top-right-radius: $border-radius-content;
            border-bottom-right-radius: $border-radius-content;
            border-bottom-left-radius: $border-radius-content;

            &:before {
                border-top: 1em solid $white !important;
            }

            .feedback-textcontent {
                display: block !important;
                height: 45px;
                overflow: hidden;

                .display-html-content {
                    overflow-x: auto;
                }

                &.collapsing {
                    min-height: 45px;
                    transition: height 0.8s ease;
                }

                &.show {
                    height: 100%;
                }
            }

            .more-and-less {
                display: flex;
                justify-content: flex-end;
                margin-top: map-get($grid-gutter-spacing, 'twenty-one');

                span {
                    font-weight: $font-weight-bold;

                    &:after {
                        padding-top: 0;
                    }
                }

                i {
                    padding-top: 0;
                }
            }
        }

        .avatar {
            display: none;
        }
    }

    .show-feedback-history {
        display: flex;
        justify-content: flex-end;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .sub-assignment-show-feedback {
        div.message-block {
            .message-content {
                .feedback-textcontent {
                    height: 25px;

                    &.collapsing {
                        min-height: 25px;
                    }
                }
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .sub-assignment-show-feedback {
        div.message-item {
            div.message-block {
                .avatar {
                    display: flex;
                }

                .message-content {
                    margin-left: 20px;
                    border-top-left-radius: 0;

                    &:before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 0;
                        border-top: 1em solid $white !important;
                        border-left: 1em solid transparent;
                        left: -13px;
                    }
                }
            }
        }
    }
}
</style>
